import { applyMiddleware, createStore, compose } from 'redux';
import createReducer from './root-reducers';
import createSagaMiddleware from '@redux-saga/core';
import { rootSaga } from './root-sagas';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import AccessCheck from './components/walls/access-check-middleware';
import { getStorelogEnabled } from './utils/storelog';

export const history = createBrowserHistory();

export const getReduxTraceEnabled = getStorelogEnabled;

const getShortPayload = payload => {
  if (typeof payload === 'undefined') return '[No Payload]';
  let text;
  try {
    text = typeof payload === 'string' ? payload : JSON.stringify(payload);
  } catch (err) {
    text = String(payload);
  }
  if (text.length <= 100) return text;
  return `${text.slice(0, 100)}...`;
};

const SENSITIVE_TRACE_ACTION_TYPES = new Set([
  'gondola_ingestEmails_SUCCESS',
  'gondola_ingestEmailDetail_SUCCESS',
  'gondola_ingestEmailSearch_SUCCESS',
  'gondola_ingestEmailSelect_SUCCESS',
]);

const isSensitiveTraceAction = action => {
  const type = action && action.type;
  return SENSITIVE_TRACE_ACTION_TYPES.has(type)
    || (typeof type === 'string'
      && type.toLowerCase().startsWith('gondola_')
      && type.toLowerCase().includes('ingestemail'));
};

export const getReduxTracePayloadPreview = action => (
  isSensitiveTraceAction(action)
    ? '[Sensitive payload redacted]'
    : getShortPayload(action && action.payload)
);

const reduxTraceMiddleware = () => next => action => {
  if (getReduxTraceEnabled()) {
    const type = action && action.type ? action.type : '[Unknown Action]';
    const payloadPreview = getReduxTracePayloadPreview(action);
    console.debug(`[redux] ${type} | ${payloadPreview}`);
  }
  return next(action);
};

export default function configureStore(populateState = {}) {
  const composeEnhancers =
    process.env.NODE_ENV === 'production'
      ? compose
      : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(
    createReducer(history),
    populateState,
    composeEnhancers(
      applyMiddleware(reduxTraceMiddleware, routerMiddleware(history), sagaMiddleware, AccessCheck)
    )
  );
  sagaMiddleware.run(rootSaga);
  return store;
}
